import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import Select from "react-select";

const FarmerFilter = ({ pagination, setPagination, agents = [] }) => {
  const [filterValues, setFilterValues] = useState(pagination);

  useEffect(() => {
    setFilterValues(pagination);
  }, [pagination]);

  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      fontSize: "13px",
      margin: 0,
    }),
  };

  const handleInputChange = (key, value) => {
    setFilterValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // Apply filters and call API through parent state
  const applyFilter = (key, value) => {
    setPagination((prev) => ({
      ...prev,
      [key]: value,
      paginationFilter: {
        ...prev.paginationFilter,
        offset: 0,
      },
    }));
  };

  const handleEnter = (event, key) => {
    if (event.key === "Enter") {
      event.preventDefault();
      applyFilter(key, filterValues[key] || "");
    }
  };

  const handleReset = () => {
    const emptyFilters = {
      search: "",
      village: "",
      registered: "",
      agentId: "",
    };

    setFilterValues((prev) => ({
      ...prev,
      ...emptyFilters,
    }));

    setPagination((prev) => ({
      ...prev,
      ...emptyFilters,
      paginationFilter: {
        ...prev.paginationFilter,
        offset: 0,
      },
    }));
  };

  return (
    <div className="filter_area collapse mb-6" id="farmerfilter">
      <div className="card-header min-h-auto py-5 justify-content-start">
        <h5 className="card-label font-weight-bold m-0">Farmer Filter</h5>
      </div>

      <div className="bg-white mb-10 p-7">
        <Row gutter={[12, 12]}>
          <Col sm={6} xs={24}>
            <label className="font-size-sm font-weight-bolder mb-2 d-block">
              Farmer Name
            </label>
            <input
              className="form-control"
              placeholder="Search by farmer name"
              value={filterValues.search || ""}
              onChange={(e) => handleInputChange("search", e.target.value)}
              onKeyDown={(e) => handleEnter(e, "search")}
            />
          </Col>

          <Col sm={6} xs={24}>
            <label className="font-size-sm font-weight-bolder mb-2 d-block">
              Village
            </label>
            <input
              className="form-control"
              placeholder="Village"
              value={filterValues.village || ""}
              onChange={(e) => handleInputChange("village", e.target.value)}
              onKeyDown={(e) => handleEnter(e, "village")}
            />
          </Col>

          <Col sm={6} xs={24}>
            <label className="font-size-sm font-weight-bolder mb-2 d-block">
              User Registered
            </label>
            <Select
              styles={customStyles}
              placeholder="User Registered"
              isClearable
              value={
                filterValues.registered === ""
                  ? null
                  : {
                      value: filterValues.registered,
                      label:
                        filterValues.registered === "true"
                          ? "Registered"
                          : "Not Registered",
                    }
              }
              options={[
                { value: "true", label: "Registered" },
                { value: "false", label: "Not Registered" },
              ]}
              onChange={(option) => {
                const value = option?.value ?? "";
                handleInputChange("registered", value);
                applyFilter("registered", value);
              }}
            />
          </Col>

          <Col sm={6} xs={24}>
            <label className="font-size-sm font-weight-bolder mb-2 d-block">
              Agents
            </label>

            <Select
              styles={customStyles}
              placeholder="Select Agent"
              isClearable
              options={agents.map((agent) => ({
                value: agent.employeeId,
                label: agent.name,
              }))}
              value={
                agents
                  .filter((agent) => agent.employeeId === filterValues.agentId)
                  .map((agent) => ({
                    value: agent.employeeId,
                    label: agent.name,
                  }))[0] || null
              }
              onChange={(option) => {
                const value = option?.value ?? "";

                setFilterValues((prev) => ({
                  ...prev,
                  agentId: value,
                }));

                setPagination((prev) => ({
                  ...prev,
                  agentId: value,
                  paginationFilter: {
                    ...prev.paginationFilter,
                    offset: 0,
                  },
                }));
              }}
            />
          </Col>

          <Col span={24}>
            <div className="d-flex justify-content-end mt-3">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleReset}
              >
                Reset
              </button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default FarmerFilter;
